import { NOTIFICATION_TIMEOUT } from "constants/common";
import EventManager from "services/eventManager";

let timer;
const showNotification = (params) => {
  let timeOut = params.timer ? params.timer : NOTIFICATION_TIMEOUT;
  if (timer) {
    clearTimeout(timer);
  }
  EventManager.publish("notify", { show: false });
  if (params.show === true) {
    EventManager.publish("notify", params);
    timer = setTimeout(() => {
      EventManager.publish("notify", { show: false });
    }, timeOut * 1000);
  }
};

export default showNotification;
